import { RegisterOptions } from 'react-hook-form'
import { FormInputProps } from './types'

export const getValidationRules = (input: FormInputProps) => {
  if (input.validation) {
    const validationRules = input.validation.reduce<RegisterOptions>((acc, validator) => {
      switch (validator.type) {
        case 'required':
          acc.required = validator.message ?? ''
          break
        case 'maxValue':
          if (validator.value !== undefined) {
            acc.max = {
              message: validator.message ?? '',
              value: validator.value,
            }
          }
          break
        case 'minValue':
          if (validator.value !== undefined) {
            acc.min = {
              message: validator.message ?? '',
              value: validator.value,
            }
          }
          break
        case 'maxLength':
          if (typeof validator.value === 'number') {
            acc.maxLength = {
              message: validator.message ?? '',
              value: validator.value,
            }
          }
          break
        case 'minLength':
          if (typeof validator.value === 'number') {
            acc.minLength = {
              message: validator.message ?? '',
              value: validator.value,
            }
          }
          break
      }

      return acc
    }, {})

    switch (input.type) {
      case 'inputEmail':
        validationRules.validate = value => {
          if (
            value &&
            // Basic email validation regex, taken from: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/email#basic_validation
            /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(
              value
            ) === false
          ) {
            return 'Please enter a valid email address.'
          }
        }
        break
    }

    return validationRules
  }
}
